<script lang="ts">
import { createFromIconfontCN } from "@ant-design/icons-vue";
const IconFont = createFromIconfontCN();
export default IconFont;
</script>
